import React from 'react';
import { H5 } from '../../AbstractElements';
import { CardHeader } from 'reactstrap';

const HeaderCard = ({ title, hover, span1, span2 }) => {
  return (
    <CardHeader className='pb-0'>
      <H5>
        {title}
        {hover}
      </H5>
      {span1 ? <span>{span1}</span> : ''}
      {span2 ? <span>{span2}</span> : ''}
    </CardHeader>
  );
};

export default HeaderCard;
